export default __webpack_public_path__ + "static/media/ic_brunei.c8016679.svg";